'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _laws = require('../actions/laws');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaultState = {};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];


    switch (action.type) {
        case _laws.actionTypes.FETCH_LAWS_SUCCEEDED:
            return action.laws;
        case _laws.actionTypes.UPDATE_LAW_DATE_SUCCEEDED:
            return _extends({}, state, _defineProperty({}, action.law.id, _extends({}, state[action.law.id], action.law)));
        default:
            return state;
    }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvcmVkdWNlcnMvbGF3cy5qcyJdLCJuYW1lcyI6WyJkZWZhdWx0U3RhdGUiLCJzdGF0ZSIsImFjdGlvbiIsInR5cGUiLCJhY3Rpb25UeXBlcyIsIkZFVENIX0xBV1NfU1VDQ0VFREVEIiwibGF3cyIsIlVQREFURV9MQVdfREFURV9TVUNDRUVERUQiLCJsYXciLCJpZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFBQTs7OztBQUVBLElBQU1BLGVBQWUsRUFBckI7O2tCQUVlLFlBQWtDO0FBQUEsUUFBakNDLEtBQWlDLHVFQUF6QkQsWUFBeUI7QUFBQSxRQUFYRSxNQUFXOzs7QUFFN0MsWUFBUUEsT0FBT0MsSUFBZjtBQUNJLGFBQUtDLGtCQUFZQyxvQkFBakI7QUFDSSxtQkFBT0gsT0FBT0ksSUFBZDtBQUNKLGFBQUtGLGtCQUFZRyx5QkFBakI7QUFDSSxnQ0FDT04sS0FEUCxzQkFFS0MsT0FBT00sR0FBUCxDQUFXQyxFQUZoQixlQUdXUixNQUFNQyxPQUFPTSxHQUFQLENBQVdDLEVBQWpCLENBSFgsRUFJV1AsT0FBT00sR0FKbEI7QUFPSjtBQUNJLG1CQUFPUCxLQUFQO0FBWlI7QUFjSCxDIiwiZmlsZSI6Imxhd3MuanMiLCJzb3VyY2VSb290IjoiL3NyYyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGFjdGlvblR5cGVzIH0gZnJvbSAnLi4vYWN0aW9ucy9sYXdzJztcblxuY29uc3QgZGVmYXVsdFN0YXRlID0ge307XG5cbmV4cG9ydCBkZWZhdWx0IChzdGF0ZSA9IGRlZmF1bHRTdGF0ZSwgYWN0aW9uKSA9PiB7XG5cbiAgICBzd2l0Y2ggKGFjdGlvbi50eXBlKSB7XG4gICAgICAgIGNhc2UgYWN0aW9uVHlwZXMuRkVUQ0hfTEFXU19TVUNDRUVERUQ6XG4gICAgICAgICAgICByZXR1cm4gYWN0aW9uLmxhd3M7XG4gICAgICAgIGNhc2UgYWN0aW9uVHlwZXMuVVBEQVRFX0xBV19EQVRFX1NVQ0NFRURFRDpcbiAgICAgICAgICAgIHJldHVybiB7XG4gICAgICAgICAgICAgICAgLi4uc3RhdGUsXG4gICAgICAgICAgICAgICAgW2FjdGlvbi5sYXcuaWRdOiB7XG4gICAgICAgICAgICAgICAgICAgIC4uLnN0YXRlW2FjdGlvbi5sYXcuaWRdLFxuICAgICAgICAgICAgICAgICAgICAuLi5hY3Rpb24ubGF3XG4gICAgICAgICAgICAgICAgfVxuICAgICAgICAgICAgfTtcbiAgICAgICAgZGVmYXVsdDpcbiAgICAgICAgICAgIHJldHVybiBzdGF0ZTtcbiAgICB9XG59OyJdfQ==


//////////////////
// WEBPACK FOOTER
// ./src/client/reducers/laws.js
// module id = 2253
// module chunks = 0